export const ON_MESSAGE_FROM_EVENT_LISTENER = 'ON_MESSAGE_FROM_EVENT_LISTENER';
